import '../GenericTable.css'
import { JSX } from 'react'
import { ColumnField } from './Column'
import { ListItemFrame } from './ListItemFrame'
import { MultiSelectEvent } from '../Models/multiSelectEvent'
import { IdLookUps } from '../../../../utils/models/idLookUp'

interface ListFrameProps<TData extends object> {
  data: TData[],
  columns: ColumnField[],
  // The row's index on the current page is passed as a third argument; the
  // existing two-argument consumers ignore it (flag listPerfEnabled: the
  // logo/design rows use it to keep the first rows eager and lazy-load the
  // rest).
  renderRow: (columns: ColumnSettings, data: TData, index: number) => JSX.Element,
  onRowSelected: (event: MultiSelectEvent<TData>) => void,
  multiSelect: boolean
  selectedData: IdLookUps<TData>
  isLoading: boolean;
  getKey?: (data: TData) => string | number,
  onClick: (data: TData) => void,
  rowColor?: ((data: TData) => string) | string
  isRowDisabled?: (data: TData) => boolean
}

function toColumnSettings(columns: ColumnField[]): ColumnSettings {
  const settings: ColumnSettings = {}
  for (const column of columns) {
    settings[column.value] = column
  }
  return settings
}

export function ListFrame<TData extends object>(
  {
    data,
    renderRow,
    columns,
    onRowSelected,
    multiSelect,
    selectedData,
    getKey,
    onClick,
    rowColor,
    isRowDisabled
  }: ListFrameProps<TData>) {

  function isChecked(data: TData): boolean {
    const key = getKey!(data);
    if (key in selectedData) {
      return true;
    }

    return false;
  }

  const columnSettings = toColumnSettings(columns)
  const rows = data.map((d, index) => {
    let bg: string = ''
    if (rowColor) {
      // @ts-ignore
      bg = (rowColor instanceof String ? rowColor : rowColor(d))
    }
    const disabled = isRowDisabled ? isRowDisabled(d) : false
    return <ListItemFrame
      bgColor={bg}
      key={getKey!(d)}
      index={index}
      isChecked={isChecked(d)}
      multiSelect={multiSelect}
      rowChecked={({ checked, index }) => onRowSelected({ checked, index, data: d })}
      onClick={() => onClick(d)}
      disabled={disabled}
    >
      {renderRow(columnSettings, d, index)}
    </ListItemFrame>
  }
  )

  return <div>
    {rows}
  </div>
}

export interface ColumnSettings {
  [key: ColumnField['value']]: ColumnField
}